module.exports = __webpack_public_path__ + "static/media/Exhaust_Fan.49f10406.png";